// Angular
import { Observable, takeUntil, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Libraries

// Services
import { AppCleanup } from '../models';

// Models
import { LocationDto } from '../models/location-dto.model';

@Injectable({
	providedIn: 'root',
})
export class LocationService extends AppCleanup {
	locations: LocationDto[] = [];
	locationUrl: string;

	constructor(private http: HttpClient) {
		super();
		this.locationUrl = `${this.apiUrl}api/location`;
	}

	initLocations() {
		this.getLocations()
			.pipe(takeUntil(this.destroy))
			.subscribe((locations) => {
				this.locations = locations;
			});
	}

	getLocations(): Observable<LocationDto[]> {
		return this.http.get<LocationDto[]>(`${this.locationUrl}`);
	}

	addLocation(locationDto: LocationDto): Observable<LocationDto> {
		return this.http.post<LocationDto>(`${this.locationUrl}`, locationDto).pipe(
			tap((locationDto) => {
				if (locationDto) {
					const locationAlreadyExists = this.locations.find((l) => l.name === locationDto.name);
					if (!locationAlreadyExists) {
						this.locations.push(locationDto);

						this.locations.sort((a, b) => {
							if (a.name < b.name) {
								return -1;
							}
							if (a.name > b.name) {
								return 1;
							}
							return 0;
						});
					}
				}
			})
		);
	}
}
